import { render, staticRenderFns } from "./ClientsModal.vue?vue&type=template&id=06d59ae1"
import script from "./ClientsModal.vue?vue&type=script&lang=js"
export * from "./ClientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports